<template>
  <div class="userCenterWarp">
    <div class="userNavWarp">
      <div class="inner">
        <ul class="userNav">
          <li v-for="(item,index) in navList" @click="goSomePage(item)" :class="{'active':$route.name==item.link}">{{item.title}}</li>
        </ul>
      </div>
    </div>
    <div class="userCenterContent">
      <router-view></router-view>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
    export default {
      data(){
        return{
          imageUrl:'',
          readName:'',
          userNum:'',
          email:'',
          navList:[
            {
              title:'用户信息',
              link:'personal'
            },
            {
              title:'联系人信息',
              link:'lxr'
            },
            {
              title:'签章管理',
              link:'qz'
            },
            {
              title:'订单管理',
              link:'dd'
            },
            {
              title:'实名认证',
              link:'userRz'
            },
            {
              title:'消息提醒',
              link:'msg'
            },
            {
              title:'意见反馈',
              link:'yjfk'
            },
            {
              title:'帮助',
              link:'helpUserCenter'
            },
          ]
        }
      },
      created(){
      },
      methods:{
        handleAvatarSuccess(){

        },
        beforeAvatarUpload(){

        },
        goSomePage(item){
          this.$router.push(`/${item.link}`)
        }
      }
    }
</script>
<style>
  @import url(../../assets/less/userCenter.css);

</style>



// WEBPACK FOOTER //
// src/components/userCenter/userCenter.vue